<template>
    <div id="app">
        <!-- <div class="p-grid" style="padding-right: 20px">
    <p
      v-if="login_success == false"
      @click="loginModal = true"
      class="login-text p-mt-3 pointer"
    >
      {{ $t("LoginButton") }}
    </p>
    <p v-else @click="toggle" class="login-text p-mt-3 pointer">
      {{ fullname }} ({{ position }})
      <i class="pi pi-user" color="rgb(0,0,0)"></i>
    </p>
    <OverlayPanel ref="op" :showCloseIcon="false">
      <Button 
      @click="$router.push('/update').catch((err) => {})" 
        label="รายการที่ต้องปรับปรุงข้อมูล" 
        class="p-button-info p-button-text" />
      <hr />
      <center>
      <Button
      @click="logout()"
                  :label="$t('Logout')"
                  class="p-button-danger"
                />
      </center>
    </OverlayPanel>
  </div> -->

        <div class="app-submenu" style="padding-right: 20px">
            <AppSubmenu
                class="layout-menu clearfix"
                :items="model"
                :layoutMode="layoutMode"
                :menuActive="active"
                :root="true"
                :parentMenuItemActive="true"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
            />
        </div>

        <!-- Login modal -->
        <Dialog :modal="true" :visible.sync="loginModal" :style="{ width: '350px' }" :header="$t('login_title')">
            <div class="confirmation-content">
                <label>{{ $t('login_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-field">
                        <label for="username">{{ $t('login_username') }}</label>
                        <InputText
                            id="username"
                            type="text"
                            v-model="username"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': error_username && !username }"
                        />
                        <small class="p-invalid" v-if="error_username && !username">{{ $t('login_validate_username') }}</small>
                    </div>
                    <div class="p-field">
                        <label for="password">{{ $t('login_password') }}</label>
                        <InputText
                            id="password"
                            type="password"
                            v-model="password"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': error_password && !password }"
                        />
                        <small class="p-invalid" v-if="error_password && !password">{{ $t('login_validate_password') }}</small>
                    </div>
                    <small class="p-invalid" v-if="login_failed == true">{{ $t('login_invalid') }}</small>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" class="p-button-text" @click="loginModal = false" />
                <Button :label="$t('login_confirm')" icon="pi pi-check" class="p-button-text" @click="checkLogin()" />
            </template>
        </Dialog>

        <!-- Add suggestion modal -->
        <Dialog :modal="true" :visible.sync="suggestionModal" :style="{ width: '700px' }" :header="$t('suggestion_modal_title')">
            <div class="confirmation-content">
                <label>{{ $t('suggestion_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-5">
                            <label for="suggest_name">{{ $t('suggest_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="suggest_name"
                                type="text"
                                v-model="suggest_name"
                                required="true"
                                autofocus
                                :class="{ 'p-invalid': error_suggest_name && !suggest_name }"
                            />
                            <small class="p-invalid" v-if="error_suggest_name && !suggest_name">{{ $t('suggest_validate_name') }}</small>
                        </div>

                        <div class="p-field p-col-7">
                            <div class="p-formgrid p-grid p-mt-0">
                                <div class="p-field p-col">
                                    <label for="suggest_email_phone">{{ $t('email') }} <span class="required-input">*</span></label>
                                    <InputText
                                        id="suggest_email_phone"
                                        type="email"
                                        v-model="suggest_email_phone"
                                        required="true"
                                        autofocus
                                        :class="{
                                            'p-invalid': (error_suggest_email_phone && !suggest_email_phone) || error_suggest_email_format == true
                                        }"
                                    />
                                    <small
                                        class="p-invalid"
                                        v-if="(error_suggest_email_phone && !suggest_email_phone) || error_suggest_email_format == true"
                                        >กรุณาระบุอีเมลให้ถูกต้อง</small
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-fluid">
                        <div class="p-field">
                            <label for="suggest_topic">{{ $t('suggest_topic') }} <span class="required-input">*</span></label>

                            <Dropdown id="suggest_topic" v-model="suggest_topic" :options="suggest_topic_options" optionLabel="name"> </Dropdown>

                            <small class="p-invalid" v-if="error_suggest_topic && !suggest_topic">{{ $t('suggest_validate_topic') }}</small>
                        </div>
                        <div class="p-field">
                            <label for="suggest_detail">{{ $t('suggest_detail') }} <span class="required-input">*</span></label>
                            <Textarea
                                id="suggest_detail"
                                type="text"
                                rows="5"
                                v-model="suggest_detail"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_suggest_detail && !suggest_detail
                                }"
                            />
                            <small class="p-invalid" v-if="error_suggest_detail && !suggest_detail">{{ $t('suggest_validate_detail') }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" class="p-button-text" @click="suggestionModal = false" />
                <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="checkSuggestion()" />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Toast />
    </div>
</template>

<script>
import AppSubmenu from './AppSubmenu';
import moment from 'moment';

export default {
    props: {
        layoutMode: String
        // active: Boolean
    },
    data() {
        return {
            date: moment().locale('th').add(543, 'year').format('l'),
            countdown: null, // Holds the countdown time in seconds
            countdownInterval: null, // Interval for countdown
            active: true,
            loginModal: false,
            username: '',
            password: '',
            fullname: '',
            position: '',
            error_username: false,
            error_password: false,
            checkStatusLogin: '',
            login_success: false,
            login_failed: false,
            addManual: true,
            suggestionModal: false,
            suggest_name: '',
            suggest_email_phone: '',
            suggest_topic: '',
            suggest_detail: '',
            error_suggest_name: false,
            error_suggest_email_phone: false,
            error_suggest_email_format: false,
            error_suggest_phone_format: false,
            error_suggest_topic: false,
            error_suggest_detail: false,
            model: [],

            displayConfirmationCloseModal: false,

            suggest_topic_options: [
                { id: 'ปัญหาการใช้งานของระบบ', name: 'ปัญหาการใช้งานของระบบ' },
                { id: 'ปัญหาข้อมูลทั่วไป', name: 'ปัญหาข้อมูลทั่วไป' }
            ],
            selectedType: { id: 'mail', name: 'อีเมล' }
        };
    },
    watch: {
        loginModal(val) {
            if (val == false) {
                this.clearData();
            }
        },
        // checkStatusLogin(val) {
        //   if (val == "failed login") {
        //     this.login_failed = true;
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เข้าสู่ระบบสำเร็จ",
        //     //   detail: "ยินดีต้อนรับ",
        //     //   life: 300000,
        //     // });
        //      this.$fire({
        //       title: "เข้าสู่ระบบสำเร็จ",
        //       text: "ยินดีต้อนรับ",
        //       type: "success",
        //       timer: 300000,
        //       confirmButtonColor: '#28B463',
        //     });
        //     debugger
        //     localStorage.setItem("username", val.user_username);
        //     localStorage.setItem("session", val.user_fullname);
        //     this.loginModal = false;
        //     location.reload();
        //   }
        // },

        suggestionModal(val) {
            if (val == false) {
                if (this.suggest_name != '' && this.suggest_email_phone != '' && this.suggest_topic != '' && this.suggest_detail != '') {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.suggestionModal = false;
                            this.clearData();
                        } else {
                            this.suggestionModal = true;
                        }
                    });
                } else {
                    this.clearData();
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.suggestionModal = true;
            }
        },

        suggest_email_phone(val) {
            if (val == '') {
                this.error_suggest_email_format = false;
            }
        }

        // selectedType(val) {
        //   // console.log("Select " + val.id);
        //   this.suggest_email_phone = "";
        // },
    },

    created() {
        var check = this.decodeJWT(localStorage.getItem('token'));
        if (check != null && this.decodeJWT(localStorage.getItem('token')) != 'failed login') {
            this.login_success = true;
            this.fullname = this.decodeJWT(localStorage.getItem('token')).user_fullname;
            this.position = this.decodeJWT(localStorage.getItem('token')).organize_name;
            let checkIsTDM = this.decodeJWT(localStorage.getItem('token')).user_username;
            if (checkIsTDM === 'TDM01' || checkIsTDM === 'TDM02' || checkIsTDM === 'TDM03') {
                this.addManual = false;
            }
        } else {
            this.login_success = false;
            this.fullname = '';
            this.position = '';
        }
    },
    beforeDestroy() {
        // Clear the interval when the component is destroyed
        clearInterval(this.countdownInterval);
    },

    methods: {
        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                return null;
            }
        },

        notifyTokenExpired() {
            this.$fire({
                title: 'Session Expired',
                text: 'Your session has expired. You will be logged out.',
                type: 'warning',
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK',
                timer: 300000
            });
        },

        //1hr
        // startTokenExpirationCountdown() {
        //     const tokenExp = localStorage.getItem('token_exp');

        //     if (tokenExp) {
        //         this.updateCountdown(); // Initial update
        //         // this.countdownInterval = setInterval(this.updateCountdown, 1000);
        //     }
        // },

        startTokenExpirationCountdown() {
            const tokenExp = localStorage.getItem('token_exp');

            if (tokenExp) {
                this.updateCountdown(); // Initial update
                this.countdownInterval = setInterval(this.updateCountdown, 1000);
            }
        },

        //1min for test
        // startTokenExpirationCountdown() {
        //     const tokenExp = localStorage.getItem('token_exp');

        //     if (tokenExp) {
        //         this.updateCountdown(); // Initial update
        //         this.countdownInterval = setInterval(this.updateCountdown, 1000); // 1 second
        //     }
        // },

        //6hr
        updateCountdown() {
            const tokenExp = new Date(localStorage.getItem('token_exp')).getTime();
            const remainingTime = tokenExp - Date.now();

            if (remainingTime <= 0) {
                clearInterval(this.countdownInterval);
                this.notifyTokenExpired();
                this.logout();
            } else {
                const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
                this.countdown = `${hours}h ${minutes}m ${seconds}s`;
            }
            // console.log(`Time to expire: ${this.countdown}`);
        },

        //1min for test
        //         updateCountdown() {
        //     const tokenExp = localStorage.getItem('token_exp');
        //     const remainingTime = tokenExp - Date.now();

        //     if (remainingTime <= 0) {
        //         clearInterval(this.countdownInterval);
        //         this.notifyTokenExpired();
        //         this.logout();
        //     } else {
        //         this.countdown = Math.floor(remainingTime / 1000);

        //         // Calculate the remaining time in seconds
        //         console.log(`Time to expire: ${this.countdown}s`);
        //     }
        // },

        async onURL() {
            await this.axios
                .get(`${this.$url_service}/file`)
                .then((response) => {
                    // console.log(response.data.data)
                    // this.url_download = response.data.url.split('?')[0]
                    this.url_download = response.data.data[0].filename;
                    // this.url_download = `https://devtdm.deemap.com/files/${fileName}`
                    // console.log(this.url_download)
                    this.downloadFile(this.url_download);
                    // this.$toast.add({severity: 'success', summary: 'Success', detail: 'ดาวน์โหลดไฟล์', life: 5000});
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        downloadFile(fileUrl) {
            window.open(`${this.$url_service}/files/${fileUrl}`, '', 'popup');
            // window.downloadFile(`${this.$url_service}/files/${fileUrl}`)

            // const link = document.createElement('a');
            // link.href = fileUrl;
            // link.download =  "data.pdf";
            // // link.setAttribute('download', 'abc');

            // document.body.appendChild(link);
            // link.click();

            // document.body.removeChild(link);
        },
        handleItemClick(item) {
            if (item.label === 'ดาวน์โหลดคู่มือการใช้งาน') {
                this.downloadManual();
            }
        },
        acceptNumber() {
            var x = this.suggest_email_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.suggest_email_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },

        closeAllModal() {
            // console.log("Close and don`t save data");
            this.suggestionModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        toggle(event) {
            this.$refs.op.toggle(event);
        },
        onMenuItemClick(event) {
            // console.log(event.item.label)
            if (event.item.label === 'ดาวน์โหลดคู่มือการใช้งาน') {
                this.onURL();
            }
            this.$emit('menuitem-click', event);
            if (localStorage.getItem('session') == null && event.item.label == 'ข้อเสนอแนะ') {
                this.suggestionModal = true;
            } else {
                // console.log("admin level");
            }
        },
        onRootMenuItemClick(event) {
            this.$emit('root-menuitem-click', event);
        },
        onMenuItemHover(event) {
            console.log(event);
            // this.model[2].items
        },

        async checkLogin() {
            if (this.username === '' || this.password === '') {
                if (this.username === '') {
                    this.error_username = true;
                }
                if (this.password === '') {
                    this.error_password = true;
                }
                this.$fire({
                    title: 'Error',
                    text: 'Username or password cannot be empty',
                    type: 'error',
                    confirmButtonColor: '#d33'
                });
            } else {
                try {
                    const response = await this.axios.post(`${this.$url_service}/get/login`, {
                        body: {
                            username: this.username,
                            password: this.password
                        }
                    });

                    this.checkStatusLogin = response.data.data;

                    if (this.checkStatusLogin === 'failed login') {
                        this.login_failed = true;
                        this.$fire({
                            title: 'เข้าสู่ระบบล้มเหลว',
                            text: 'กรุณากรอก username password ให้ถูกต้อง',
                            type: 'error',
                            confirmButtonColor: '#d33'
                        });
                    } else {
                        // Store the JWT token and expiration time in localStorage
                        const token = response.data.token;
                        const expiresAt = new Date(Date.now() + 6 * 60 * 60 * 1000).toISOString(); // 6 hours from now

                        localStorage.setItem('token', token);

                        localStorage.setItem('token_exp', expiresAt);

                        // Start the countdown timer for token expiration
                        this.startTokenExpirationCountdown();

                        this.$fire({
                            title: 'เข้าสู่ระบบสำเร็จ',
                            text: 'ยินดีต้อนรับ',
                            type: 'success',
                            timer: 300000,
                            confirmButtonColor: '#28B463'
                        });

                        localStorage.setItem('username', this.checkStatusLogin.user_username);
                        localStorage.setItem('session', this.checkStatusLogin.user_fullname);
                        this.loginModal = false;
                        location.reload();
                    }
                } catch (error) {
                    console.error('Login failed:', error);
                    this.$fire({
                        title: 'เข้าสู่ระบบล้มเหลว',
                        text: 'กรุณากรอก username password ให้ถูกต้อง',
                        type: 'error',
                        confirmButtonColor: '#d33'
                    });
                }
            }
        },
        async checkSuggestion() {
            if (this.suggest_name == '' || this.suggest_email_phone == '' || this.suggest_topic == '' || this.suggest_detail == '') {
                if (this.suggest_name == '') {
                    this.error_suggest_name = true;
                }
                if (this.suggest_email_phone == '') {
                    this.error_suggest_email_phone = true;
                }
                if (this.suggest_topic == '') {
                    this.error_suggest_topic = true;
                }
                if (this.suggest_detail == '') {
                    this.error_suggest_detail = true;
                }
            } else {
                var check;
                if (this.selectedType.id == 'mail') {
                    var re =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    check = re.test(this.suggest_email_phone);
                    // console.log("Email validate : " + check);
                }

                if (check == false) {
                    this.error_suggest_email_format = true;
                } else {
                    const receive = new Date();
                    const ye1 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(receive);
                    const mo1 = new Intl.DateTimeFormat('en', {
                        month: '2-digit'
                    }).format(receive);
                    const da1 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(receive);
                    const receivedate = `${ye1}-${mo1}-${da1}`;

                    let result = await this.axios
                        .post(`${this.$url_service}/get/suggestion`, {
                            body: {
                                topic: 'add-suggestion',
                                date: receivedate,
                                name: this.suggest_name,
                                contact: this.suggest_email_phone,
                                stopic: this.suggest_topic.id,
                                detail: this.suggest_detail
                            }
                        })
                        .then((resp) => {
                            return resp;
                        });
                    if (result) {
                        this.suggestionModal = false;
                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "เพิ่มข้อเสนอแนะสำเร็จ",
                        //   detail: "สำหรับผู้ใช้ทั่วไป",
                        //   life: 3000,
                        // });

                        this.$fire({
                            title: 'เพิ่มข้อเสนอแนะสำเร็จ',
                            text: 'สำหรับผู้ใช้ทั่วไป',
                            type: 'success',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.clearData();
                    } else {
                        // this.$toast.add({
                        //   severity: "danger",
                        //   summary: "เพิ่มข้อเสนอแนะไม่สำเร็จ",
                        //   detail: "มีข้อผิดพลาด",
                        //   life: 3000,
                        // });

                        this.$fire({
                            title: 'มีข้อผิดพลาด',
                            text: 'เพิ่มข้อเสนอแนะไม่สำเร็จ',
                            type: 'error',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                    }
                }
            }
        },

        clearData() {
            this.username = '';
            this.password = '';
            this.login_failed = false;
            this.error_username = false;
            this.error_password = false;

            this.suggest_name = '';
            this.suggest_email_phone = '';
            this.suggest_topic = '';
            this.suggest_detail = '';
            this.selectedType = { id: 'mail', name: 'อีเมล' };
            this.error_suggest_name = false;
            this.error_suggest_email_phone = false;
            this.error_suggest_topic = false;
            this.error_suggest_detail = false;
        },

        // logout() {
        //     localStorage.removeItem('token');
        //     localStorage.removeItem('token_exp');
        //     localStorage.removeItem('data');
        //     localStorage.removeItem('username');
        //     localStorage.removeItem('session');
        //     this.$router.push('/statistic-disaster');
        //     location.reload();
        // }

        logout() {
            console.log('Logging out due to token expiration...');
            localStorage.removeItem('token');
            localStorage.removeItem('token_exp');
            localStorage.removeItem('data');
            localStorage.removeItem('username');
            localStorage.removeItem('session');
            location.reload(); // Reload to clear any state
        }
    },

    mounted() {
        this.startTokenExpirationCountdown();

        const tokenExp = localStorage.getItem('token_exp');
        if (tokenExp && Date.now() > tokenExp) {
            // Token has expired, clear the storage and force logout
            this.notifyTokenExpired();
            localStorage.removeItem('token');
            localStorage.removeItem('data');
            localStorage.removeItem('token_exp');
            this.logout(); // Call the logout function
        }

        const token = localStorage.getItem('token');

        if (token) {
            const decodedToken = this.decodeJWT(token);

            if (decodedToken != null && decodedToken != 'failed login') {
                this.model = [
                    {
                        // label: "แผนที่สาธารณภัย",
                        // icon: "pi pi-fw pi-map-marker",
                        label: 'หน้าหลัก',
                        icon: 'pi pi-fw pi-home',
                        to: '/map-disaster'
                    },
                    // {
                    //   label: "ภาพรวม",
                    //   icon: "pi pi-spin pi-cog",
                    //   to: "/Overview",
                    // },
                    {
                        label: 'สถิติสาธารณภัย',
                        icon: 'pi pi-fw pi-chart-bar',
                        // to: "/statistic-disaster",
                        items: [
                            {
                                label: 'ตามประเภทสาธารณภัย     ',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/statistic/disaster",
                                items: [
                                    {
                                        label: 'จัดกลุ่มตามช่วงเวลา',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/disasterRangeTime',
                                        class: 'menulist123'
                                    },
                                    {
                                        label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/disasterYear'
                                    }
                                ]
                            },
                            {
                                label: 'ตามระดับความรุนแรง',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/statistic/level",
                                items: [
                                    {
                                        label: 'จัดกลุ่มตามช่วงเวลา',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/levelRangeTime'
                                    },
                                    {
                                        label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/levelYear'
                                    }
                                ]
                            },
                            {
                                label: 'ตามหน่วยงานรับผิดชอบ',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/statistic/organize",
                                items: [
                                    {
                                        label: 'จัดกลุ่มตามช่วงเวลา',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/organizeRangeTime'
                                    },
                                    {
                                        label: 'จัดกลุ่มตามหน่วยงานรับผิดชอบ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/organizeResponse'
                                    },
                                    {
                                        label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/organizeYear'
                                    }
                                ]
                            },
                            {
                                label: 'ตามพี้นที่เกิดเหตุ',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/statistic/location",
                                items: [
                                    {
                                        label: 'จัดกลุ่มตามช่วงเวลา',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/locationRangeTime'
                                    },
                                    {
                                        label: 'จัดกลุ่มตามพื้นที่เกิดเหตุ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/locationEvent'
                                    },
                                    {
                                        label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/statistic/locationYear'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        label: 'ข้อมูลสารสนเทศ',
                        icon: 'pi pi-fw pi-list',
                        // to: "/information",
                        items: [
                            {
                                label: 'ข้อมูลระบบ',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/information/system",
                                items: [
                                    {
                                        label: 'ข้อมูลพื้นฐานระบบ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/system/general'
                                    },
                                    {
                                        label: 'ข้อมูลจังหวัด, อำเภอ, ตำบล',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/system/country'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลตั้งต้น',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/information/initial",
                                items: [
                                    {
                                        label: 'Search'
                                    },
                                    {
                                        label: 'ข้อมูลพื้นที่อพยพ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/evacuation'
                                    },
                                    {
                                        label: 'ข้อมูลระดับความเสี่ยง',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/risk_level'
                                    },
                                    {
                                        label: 'ข้อมูลพื้นที่เสี่ยงภัย',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/risk_area'
                                    },
                                    {
                                        label: 'ข้อมูลหน่วยงาน',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/organization'
                                    },
                                    {
                                        label: 'ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/disaster_prevent'
                                    },
                                    {
                                        label: 'ข้อมูลหลักสูตรการฝึกอบรม',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/course'
                                    },
                                    {
                                        label: 'ข้อมูลกำลังคน',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/man_power'
                                    },
                                    {
                                        label: 'ข้อมูลอาสาสมัคร',
                                        icon: 'pi pi-fw pi-caret-right',
                                        items: [
                                            {
                                                label: 'อปพร.',
                                                icon: 'pi pi-fw pi-caret-right',
                                                to: '/information/initial/volunteer'
                                            },
                                            {
                                                label: 'อาสาสมัครในพื้นที่กรุงเทพมหานคร',
                                                icon: 'pi pi-fw pi-caret-right',
                                                to: '/information/initial/volunteer/bangkok'
                                            },
                                            {
                                                label: 'อาสาสมัคร มูลนิธิ กู้ชีพ กู้ภัย',
                                                icon: 'pi pi-fw pi-caret-right'
                                            }
                                        ]
                                    },
                                    {
                                        label: 'ข้อมูลอุปกรณ์สำนักงาน',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/device'
                                    },
                                    {
                                        label: 'ข้อมูลชุดเผชิญเหตุ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/incident'
                                    },
                                    {
                                        label: 'ข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/equipment_vehicle'
                                    },
                                    {
                                        label: 'ข้อมูลอาคาร/สิ่งปลูกสร้าง',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/building'
                                    },
                                    {
                                        label: 'UN Number',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/UN_Number'
                                    },
                                    {
                                        label: 'ข้อมูลหัวจ่ายน้ำดับเพลิง',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/FireHydrant'
                                    },
                                    {
                                        label: 'ข้อมูลถังดับเพลิง',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/Extinguisher'
                                    },
                                    {
                                        label: 'ข้อมูลสถานีชาร์จรถยนต์ไฟฟ้า',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/ev-stations'
                                    },
                                    {
                                        label: 'ข้อมูลชุมชน',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/Community'
                                    },
                                    {
                                        label: 'ข้อมูลสถานีดับเพลิงและกู้ภัย',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/FireStation'
                                    },
                                    {
                                        label: 'เครื่องอุปโภค บริโภค',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/Consumables'
                                    },
                                    {
                                        label: 'ข้อมูลสถานประกอบการ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/public-organization'
                                    },
                                    {
                                        label: 'ข้อมูลจุดอาสาสมัคร',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/information/initial/volunteer-rescue'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลสาธารณภัย (รับแจ้งจากประชาชน)',
                                icon: 'pi pi-fw pi-circle-off',
                                to: '/information/disaster/people'
                            },
                            {
                                label: 'ข้อมูลสาธารณภัย',
                                icon: 'pi pi-fw pi-circle-off',
                                to: '/information/disaster'
                            },
                            {
                                label: 'ข้อมูลผู้ประสบภัย',
                                icon: 'pi pi-fw pi-circle-off',
                                to: '/information/victim'
                            },
                            {
                                label: 'สถิติจำนวนบุคลากร',
                                icon: 'pi pi-fw pi-circle-off',
                                to: '/information/population'
                            }
                        ]
                    },
                    {
                        label: 'รายงาน',
                        icon: 'pi pi-fw pi-file',
                        items: [
                            {
                                label: 'ข้อมูลกำลังคน',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/report/officer",
                                items: [
                                    {
                                        label: 'รายละเอียดข้อมูลเจ้าหน้าที่',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/officerDetail'
                                    },
                                    {
                                        label: 'สรุปจำนวนเจ้าหน้าที่',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/officerAmount'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลเครื่องมือฯ',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/report/equipment",
                                items: [
                                    {
                                        label: 'รายละเอียดข้อมูลเครื่องมือฯ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/equipmentDetail'
                                    },
                                    {
                                        label: 'ประวัติการซ่อมบำรุง',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/equipmentMaintenance'
                                    },
                                    {
                                        label: 'ประวัติการยืม',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/equipmentBorrowing'
                                    },
                                    {
                                        label: 'สรุปรายงานความพร้อมเครื่องมือ อุปกรณ์/ยานพาหนะ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/equipmentInvestigation'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลพื้นที่เสี่ยงภัย',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/report/riskarea",
                                items: [
                                    {
                                        label: 'สรุปจำนวนพื้นที่เสี่ยงภัย',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/riskareaAmount'
                                    },
                                    {
                                        label: 'กราฟสรุปจำนวนพื้นที่เสี่ยงภัย',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/riskareaGraph'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลอาคาร',
                                icon: 'pi pi-fw pi-circle-off',
                                to: '/report/building'
                            },
                            {
                                label: 'ข้อมูลสาธารณภัย',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/report/disaster",
                                items: [
                                    {
                                        label: 'รายละเอียดข้อมูล',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/disasterDetail'
                                    },
                                    {
                                        label: 'สรุปจำนวนเหตุการณ์',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/disasterAmount'
                                    },
                                    {
                                        label: 'กราฟสรุปตามประเภทสาธารณภัย (รายเดือน)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/disasterGraphMonth'
                                    },
                                    {
                                        label: 'กราฟสรุปตามประเภทสาธารณภัย (รายปี)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/disasterGraphYear'
                                    },
                                    {
                                        label: 'กราฟสรุปตามพื้นที่เกิดเหตุ (รายเดือน)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/disasterLocationGraphMonth'
                                    },
                                    {
                                        label: 'กราฟสรุปตามพื้นที่เกิดเหตุ (รายปี)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/disasterLocationGraphYear'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลผู้ประสบภัย',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/report/victim",
                                items: [
                                    {
                                        label: 'รายละเอียด',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimDetail'
                                    },
                                    {
                                        label: 'สรุปจำนวนผู้ประสบภัย',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimAmount'
                                    },
                                    {
                                        label: 'กราฟตามประเภทสาธารณภัย (รายเดือน)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimDisasterGraphMonth'
                                    },
                                    {
                                        label: 'กราฟตามประเภทสาธารณภัย (รายปี)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimDisasterGraphYear'
                                    },
                                    {
                                        label: 'กราฟตามพื้นที่เกิดเหตุ (รายเดือน)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimLocationGraphMonth'
                                    },
                                    {
                                        label: 'กราฟตามพื้นที่เกิดเหตุ (รายปี)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimLocationGraphYear'
                                    },
                                    {
                                        label: 'สรุปมูลค่าขอความช่วยเหลือ',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/victimConclusion'
                                    }
                                ]
                            },
                            {
                                label: 'ข้อมูลการใช้งานระบบ',
                                icon: 'pi pi-fw pi-circle-off',
                                to: '/report/logs'
                            },
                            {
                                label: 'รายงานประจำวัน',
                                icon: 'pi pi-fw pi-circle-off',
                                // to: "/report/daily",
                                items: [
                                    {
                                        label: 'รายงานเหตุเพลิงไหม้ (ว.๘/๐๐๑)',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/dailyFire'
                                    },
                                    {
                                        label: 'รายงานเหตุสาธารณภัยและบริการประชาชน',
                                        icon: 'pi pi-fw pi-caret-right',
                                        to: '/report/dailyDisaster'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        // label: "หน้าหลักสำนัก",
                        label: 'เว็บไซต์สำนัก',
                        icon: 'pi pi-fw pi-globe',
                        // url: "http://www.praram199.com/praram/home",
                        url: 'http://www.bangkokfire199.com/'
                    },
                    {
                        label: 'ข้อเสนอแนะ',
                        icon: 'pi pi-fw pi-comments',
                        to: '/suggestion'
                    },
                    {
                        label: 'คู่มือการใช้งาน',
                        icon: 'pi pi-fw pi-book',
                        items: [
                            {
                                label: 'ดาวน์โหลดคู่มือการใช้งาน',
                                icon: 'pi pi-fw pi-circle-off'
                            },
                            {
                                label: 'เพิ่มคู่มือการใช้งาน',
                                icon: 'pi pi-fw pi-circle-off',
                                to: this.addManual === false ? '/manual/addManual' : '/',
                                disabled: this.addManual
                            }
                        ]
                    },
                    {
                        label: 'ออกจากระบบ',
                        icon: 'pi pi-fw pi-sign-out',
                        command: () => {
                            this.logout();
                        }
                    }
                ];
                // for(let i=0; i<this.model.length; i++){
                //  this.model[i].addEventListener('click', function(e){
                //   console.log(e)
                //  })
                // }
                let checkRole = this.decodeJWT(token).permission_id;

                //Top admin can view admin menu
                if (checkRole == 'pl-000001' || checkRole == 'pl-000002') {
                    this.model[2].items.push({
                        label: 'ผู้ดูแลระบบ',
                        icon: 'pi pi-fw pi-circle-off',
                        // to: "/information/administrator",
                        items: [
                            {
                                label: 'ข้อมูลระดับสิทธิ์',
                                icon: 'pi pi-fw pi-caret-right',
                                to: '/information/administrator/permission'
                            },
                            {
                                label: 'ข้อมูลผู้ใช้งานระบบ',
                                icon: 'pi pi-fw pi-caret-right',
                                to: '/information/administrator/user'
                            }
                        ]
                    });
                }
            }
        } else {
            if (window.location.pathname == '/information/initial/Extinguisher') {
                return this.$router.push(`/public/information/initial/Extinguisher${window.location.search}`);
            }
            this.$router.push('/map-disaster');
            this.model = [
                {
                    // label: "แผนที่สาธารณภัย",
                    // icon: "pi pi-fw pi-map-marker",
                    label: 'หน้าหลัก',
                    icon: 'pi pi-fw pi-home',
                    to: '/map-disaster'
                },
                {
                    label: 'สถิติสาธารณภัย',
                    icon: 'pi pi-fw pi-chart-bar',
                    to: '/statistic-disaster'
                },
                {
                    // label: "หน้าหลักสำนัก",
                    label: 'เว็บไซต์สำนัก',
                    icon: 'pi pi-fw pi-globe',
                    //url: "http://www.praram199.com/praram/home",
                    url: 'http://www.bangkokfire199.com/'
                },
                {
                    label: 'ข้อเสนอแนะ',
                    icon: 'pi pi-fw pi-comments'
                    // to: "/statistic-disaster",
                },
                {
                    label: 'ลงชื่อเข้าใช้ระบบ',
                    icon: 'pi pi-fw pi-sign-in',
                    command: () => {
                        this.loginModal = true;
                    }
                }
            ];
        }
    },
    components: {
        AppSubmenu: AppSubmenu
    }
};
</script>

<style scoped>
.login-text {
    color: rgb(255, 255, 255);
    margin-left: auto;
    font-size: 16px;
}

.p-grid {
    margin-right: 0rem;
}

.p-overlaypanel:before {
    display: none !important;
}

.p-overlaypanel:after {
    display: none !important;
}

@media screen and (max-width: 550px) {
    .login-text {
        margin-left: auto;
        font-size: 10px;
    }
}

@media screen and (max-width: 991px) {
    /* .p-grid{
margin-right: 0rem;
} */
}
</style>
